export const ROUTE_COMPANY_PROFILE = `/activation/:externalCompanyId/company-profile`
const ROUTE_UNDERWRITING = `/activation/:externalCompanyId/company-underwriting`
const ROUTE_COMPANY_FINANCIALS = `${ROUTE_UNDERWRITING}/financials`
const ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING = `${ROUTE_COMPANY_FINANCIALS}/yearly-closing`
export const ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_COMPANY_FINANCIAL_STATEMENTS = `${ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING}/company-financial-statements`
export const ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_GROUP_FINANCIAL_STATEMENTS = `${ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING}/group-financial-statements`
export const ROUTE_COMPANY_SELLER_TRADE_PARTNER_DOCUMENTS =
  '/activation/:externalCompanyId/company-underwriting/buyers/:externalId/documents'
export const ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE =
  '/activation/:externalCompanyId/company-underwriting/buyers/:externalId/profile'
